module.exports = __webpack_public_path__ + "img/symbol_7.32ed70ee.png";